import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/useAuth";
import { AppLayout } from "../../components/AppLayout";

export const AppContainer: FC = () => {
  const { authenticated, authorizedCompanyId } = useAuth();
  const location = useLocation();
  if (!authenticated) {
    return <Navigate to='/auth' />;
  }

  if (location.pathname !== "/profile" ? !authorizedCompanyId : false) {
    return <Navigate to='/selectcompanies' />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};
